import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Card } from 'components/card'
import { Grid, Col } from 'components/grid'
import { pushDataLayer } from 'utils/push-data-layer'

import { OtherProductItem, OtherProductsProps } from './other-products.model'
import * as S from './styles'

const renderProducts = (products: OtherProductItem[], dataLayerAction: string) =>
  products.map(product => {
    const ProductIcon = product.icon
    const dataLayer = {
      category: 'Clique',
      action: dataLayerAction,
      label: `Outros Produtos - ${product.title}`
    }

    return (
      <Card
        key={product.link}
        link={product.link}
        ariaLabel={`Saiba mais sobre ${product.title}`}
        dataLayer={dataLayer}
      >
        <S.CardContent>
          <ProductIcon color="#1854FF" />
          <Text as="h3" color="var(--colors-neutral-text-default)" size="heading3" weight="medium">
            <S.TitleLink href={product.link} onClick={() => pushDataLayer(dataLayer)}>
              {product.title}
            </S.TitleLink>
          </Text>
          <Text color="var(--colors-neutral-text-weak)" size="body1">
            {product.description}
          </Text>
        </S.CardContent>
      </Card>
    )
  })

export const OtherProducts = memo<OtherProductsProps>(
  ({ products, mobileProducts, dataLayerAction, cardsColDesktop = 11 }) => (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 1 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <Text as="h2" aria-label="Conheça outros produtos da CashMe" size="heading3" weight="medium">
            Conheça{' '}
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-contrast)">
              outros produtos{' '}
            </Text>
            da CashMe
          </Text>
        </Col>
        <Col col={{ desktop: cardsColDesktop }} start={{ desktop: 2 }}>
          <S.CardsWrapper $variant={mobileProducts ? 'desktop' : 'all'}>
            {renderProducts(products, dataLayerAction)}
          </S.CardsWrapper>
          {mobileProducts && (
            <S.CardsWrapper $variant="mobile">{renderProducts(mobileProducts, dataLayerAction)}</S.CardsWrapper>
          )}
        </Col>
      </Grid>
    </S.Section>
  )
)

OtherProducts.displayName = 'OtherProducts'
